'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntersectionObserver = require('react-intersection-observer');

var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


var isFunction = function isFunction(func) {
  return typeof func === 'function';
};

/**
 * Monitors scroll, and triggers the children function with updated props
 *
 <ScrollPercentage>
 {({inView, percentage}) => (
   <h1>{`${inView} {percentage}`}</h1>
 )}
 </ScrollPercentage>
 */

var ScrollPercentage = function (_PureComponent) {
  _inherits(ScrollPercentage, _PureComponent);

  function ScrollPercentage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollPercentage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollPercentage.__proto__ || Object.getPrototypeOf(ScrollPercentage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      percentage: 0,
      inView: false
    }, _this.observer = null, _this.handleChange = function (inView) {
      _this.setState({ inView: inView });
    }, _this.handleNode = function (node) {
      return _this.observer = node;
    }, _this.handleScroll = function () {
      return requestAnimationFrame(function () {
        return _this.updatePercentage();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollPercentage, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (!nextProps.onChange) return;
      if (nextState.percentage !== this.state.percentage || nextState.inView !== this.state.inView) {
        nextProps.onChange(_extends({}, this.state));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.inView !== this.state.inView) {
        this.monitorScroll(this.state.inView);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.monitorScroll(false);
      this.observer = null;
    }
  }, {
    key: 'monitorScroll',
    value: function monitorScroll(enable) {
      if (enable) {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
      } else {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: 'updatePercentage',
    value: function updatePercentage() {
      var threshold = this.props.threshold;

      var _observer$node$getBou = this.observer.node.getBoundingClientRect(),
          bottom = _observer$node$getBou.bottom,
          height = _observer$node$getBou.height;

      var percentage = ScrollPercentage.calculatePercentage(height, bottom, threshold);

      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          threshold = _props.threshold,
          props = _objectWithoutProperties(_props, ['children', 'threshold']);

      return _react2.default.createElement(_reactIntersectionObserver2.default, _extends({}, props, {
        onChange: this.handleChange,
        ref: this.handleNode
      }),
      // If children is a function, render it with the current percentage and inView status.
      // Otherwise always render children. Assume onChange is being used outside, to control the the state of children.
      isFunction(children) ? children({
        percentage: this.state.percentage,
        inView: this.state.inView
      }) : children);
    }
  }], [{
    key: 'viewportHeight',


    /**
     * Get the correct viewport height. If rendered inside an iframe, grab it from the parent
     */
    value: function viewportHeight() {
      return global.parent ? global.parent.innerHeight : global.innerHeight;
    }
  }, {
    key: 'calculatePercentage',
    value: function calculatePercentage(height, bottom) {
      var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var vh = ScrollPercentage.viewportHeight();
      var offsetTop = threshold * vh * 0.25;
      var offsetBottom = threshold * vh * 0.25;

      return 1 - Math.max(0, Math.min(1, (bottom - offsetTop) / (vh + height - offsetBottom - offsetTop)));
    }
  }]);

  return ScrollPercentage;
}(_react.PureComponent);

ScrollPercentage.propTypes = {
  /** Element tag to use for the wrapping */
  tag: _propTypes2.default.node,
  /** Children should be either a function or a node */
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  /** Call this function whenever the percentage changes */
  onChange: _propTypes2.default.func,
  /** Number between 0 and 1 indicating the the percentage that should be visible before triggering */
  threshold: _propTypes2.default.number
};
ScrollPercentage.defaultProps = {
  tag: 'div',
  threshold: 0 };
exports.default = ScrollPercentage;


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-percentage/es/index.js
// module id = 382
// module chunks = 0